var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _animateTransform, _animateTransform2, _animateTransform3, _animateTransform4, _animateTransform5, _animateTransform6, _animateTransform7, _animateTransform8, _animateTransform9, _animateTransform10, _animateTransform11, _animateTransform12, _animateTransform13, _animateTransform14, _animateTransform15, _animateTransform16, _animateTransform17, _animateTransform18, _animateTransform19, _animateTransform20, _animateTransform21, _animateTransform22, _animateTransform23, _animateTransform24, _animateTransform25, _animateTransform26, _animateTransform27, _animateTransform28, _animateTransform29, _animateTransform30, _animateTransform31, _animateTransform32, _animateTransform33, _animateTransform34, _animateTransform35, _animateTransform36, _animateTransform37, _animateTransform38, _animateTransform39, _animateTransform40, _animate, _animate2, _animateTransform41, _animateTransform42;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: 392,
    viewBox: "0 0 374 470",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 392,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "392_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h374v0v470v0h-374v0v-470z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#392_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,17,227.4102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 395,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 396,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,13.684600000000003,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 397,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "397_fill_path",
    d: "M0.4772,16.92c1.29221,5.61987 4.05286,10.79609 8,15c2.01561,-5.4006 2.56086,-11.23959 1.58,-16.92c-1.28448,-5.62276 -4.04615,-10.8009 -8,-15c-2.01938,5.39973 -2.56473,11.23974 -1.58,16.92z",
    fillRule: "nonzero",
    fill: "rgb(86, 175, 150)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,22.7157,3.1899999999999977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 398,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "398_fill_path",
    d: "M11.99618,17c-1.88,8.82 -9.17,15 -9.17,15c0,0 -4.23,-8.14 -2.34,-17c1.89,-8.86 9.17,-15 9.17,-15c0,0 4.23,8.18 2.34,17z",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,9.170000000000016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 399,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "399_fill_path",
    d: "M4.59185,24.78c5.38,12.16 14.92,26.25 14.92,26.25c0,0 0.82,-19.62 -4.56,-31.78c-3.40843,-7.48977 -8.51714,-14.08111 -14.92,-19.25c-0.27888,8.49175 1.27646,16.9438 4.56,24.78z",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,28.913800000000002,8.519900000000007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3910,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3910_fill_path",
    d: "M14.048,25.07001c-4.65,12.5 -13.8,27.26001 -13.8,27.26001c0,0 -1.55,-19.54002 3.1,-32.00002c2.97662,-7.74709 7.69886,-14.70383 13.8,-20.33c0.7717,8.4822 -0.28542,17.03126 -3.1,25.07001z",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.887599999999999,9.370000000000005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3911,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3911_fill_path",
    d: "M1.16428,21.64999c2.66,11.21 9.58,25.93001 9.58,25.93001c0,0 2.62,-17.45 0,-28.66c-1.73289,-6.94771 -5.01094,-13.41493 -9.59,-18.92c-1.54241,7.13461 -1.539,14.51681 0.01,21.64999z",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.0644,15.849900000000048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3912,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3912_fill_path",
    d: "M0.82741,18.65001c2.26,9.55 8.87,22.92 8.87,22.92c0,0 2.93,-16.10001 0.67,-25.65001c-1.53512,-5.98246 -4.59063,-11.46652 -8.87,-15.92c-1.73652,6.0697 -1.9665,12.47135 -0.67,18.65001z",
    fillRule: "nonzero",
    fill: "rgb(82, 178, 146)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,22.846400000000003,13.050000000000011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3913,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3913_fill_path",
    d: "M0.18548,20.25999c-1.23,11.64 4.06,29.88998 4.06,29.88998c0,0 7.31,-16.62999 8.55,-28.26999c1.24,-11.64 -4.06,-21.87999 -4.06,-21.87999c0,0 -7.3,8.61999 -8.55,20.25999z",
    fillRule: "nonzero",
    fill: "rgb(86, 175, 150)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,18.671799999999998,20.220000000000027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3914,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3914_fill_path",
    d: "M0,23.28c0.1567,5.763 1.84074,11.38106 4.88,16.28c3.04499,-4.89695 4.73268,-10.51569 4.89,-16.28c0,-9 -4.89,-23.28 -4.89,-23.28c0,0 -4.88,14.29 -4.88,23.28z",
    fillRule: "nonzero",
    fill: "rgb(164, 211, 186)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.631599999999999,45.77010000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3915,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3915_fill_path",
    d: "M23.15026,3.49982c-0.09,-0.81 -23.24,-4.2 -23.15,-3.37l2.82,25.17001c0.01847,0.17041 0.10062,0.32757 0.23,0.44c0.0546,0.07897 0.12795,0.14313 0.21348,0.18677c0.08552,0.04363 0.18054,0.06537 0.27652,0.06323h18.24c0.45,0 0.64,-0.1 0.76,-0.41c0.0901,-0.26585 0.15047,-0.54086 0.18,-0.82001c0.70667,-7.06667 1.28,-14.15334 1.72,-21.26001c0.09,-0.83 -1.24,-0.82 -1.29,0z",
    fillRule: "nonzero",
    fill: "rgb(173, 153, 138)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.508499999999998,44.31990000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3916,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3916_fill_path",
    d: "M29.19338,0.64c-0.5,-0.54 -1.54,-0.64 -3.54,-0.64h-21.79c-2,0 -3,0.06001 -3.47,0.57001c-0.47,0.51 -0.41,1.12 -0.36,2.23v2.29001c0,1.55 0,2.4 0.5,2.92c0.5,0.52 1.56,0.58 3.3,0.58h21.82c2,0 2.93,0 3.44,-0.55c0.51,-0.55 0.42,-1.13001 0.38,-2.35001v-1.39c0,-0.53 0,-1.14 0.06,-1.59c0.05,-0.97 0.12,-1.61001 -0.34,-2.07001z",
    fillRule: "nonzero",
    fill: "rgb(193, 171, 157)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.7714,45.156300000000044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3917,
    opacity: 0.49000000953674316,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3917_fill_path",
    d: "M0.32047,0.27368c-0.31266,1.1013 -0.39772,2.25475 -0.25,3.39c0.07,0.52 0.89,0.53 0.82,0c-0.14238,-1.06397 -0.06754,-2.14576 0.22,-3.17999c0.01853,-0.10145 -0.00184,-0.20616 -0.05707,-0.29326c-0.05523,-0.08709 -0.14125,-0.15017 -0.24092,-0.17667c-0.09967,-0.02649 -0.20566,-0.01445 -0.29685,0.03372c-0.09119,0.04817 -0.16087,0.12893 -0.19516,0.2262zM0.86047,5.31369c0.10874,0 0.21303,-0.0432 0.28992,-0.12009c0.07689,-0.07689 0.12008,-0.18118 0.12008,-0.28992c0,-0.10874 -0.04319,-0.21303 -0.12008,-0.28992c-0.07689,-0.07689 -0.18118,-0.12009 -0.28992,-0.12009c-0.10874,0 -0.21302,0.0432 -0.28991,0.12009c-0.07689,0.07689 -0.12009,0.18118 -0.12009,0.28992c0,0.10874 0.0432,0.21303 0.12009,0.28992c0.07689,0.07689 0.18117,0.12009 0.28991,0.12009zM21.70047,13.91368c-0.17,0.74 -0.37,1.85002 0.57,2.16002c0.94,0.31 1.43,-0.49001 1.48,-1.23001c0.06567,-0.38126 0.00315,-0.77354 -0.17778,-1.11549c-0.18093,-0.34196 -0.47007,-0.61432 -0.82222,-0.77451c-0.21376,-0.04376 -0.43573,-0.02236 -0.63719,0.06143c-0.20146,0.08379 -0.37314,0.22613 -0.49281,0.40857c-0.08016,0.13047 -0.1408,0.27197 -0.18,0.42c-0.06,0.25 0,0.46999 0,0.70999c-0.04486,0.20895 -0.01031,0.42713 0.09692,0.612c0.10722,0.18487 0.27944,0.32318 0.48309,0.388c0.20938,0.0523 0.43089,0.021 0.61758,-0.08728c0.18668,-0.10828 0.32385,-0.28501 0.38242,-0.49272c0.01033,-0.16984 0.01033,-0.34015 0,-0.50999v-0.19c0,-0.25 -0.11,-0.16999 -0.31,0.26001h-0.44c-0.17,-0.06 -0.28,-0.24001 -0.16,0.07999c0.12,0.32 -0.32,0 0.27,-0.12h0.44c0.24,0.05 0.33,0.83 0.4,0.25c0.01216,-0.13583 0.03898,-0.26994 0.08,-0.39999c0.24,-1 -1.35,-1.47 -1.59,-0.44zM23.29047,12.66368c0.21748,0 0.42605,-0.08639 0.57983,-0.24017c0.15378,-0.15378 0.24017,-0.36234 0.24017,-0.57982c0,-0.21748 -0.08639,-0.42605 -0.24017,-0.57983c-0.15378,-0.15378 -0.36235,-0.24017 -0.57983,-0.24017c-0.21748,0 -0.42605,0.08639 -0.57983,0.24017c-0.15378,0.15378 -0.24017,0.36236 -0.24017,0.57983c0,0.21748 0.08639,0.42604 0.24017,0.57982c0.15378,0.15378 0.36235,0.24017 0.57983,0.24017zM23.02047,17.87368c0.21748,0 0.42605,-0.08639 0.57983,-0.24017c0.15378,-0.15378 0.24017,-0.36236 0.24017,-0.57983c0,-0.21748 -0.08639,-0.42605 -0.24017,-0.57983c-0.15378,-0.15378 -0.36235,-0.24017 -0.57983,-0.24017c-0.21748,0 -0.42605,0.08639 -0.57983,0.24017c-0.15378,0.15378 -0.24017,0.36236 -0.24017,0.57983c0,0.21748 0.08639,0.42605 0.24017,0.57983c0.15378,0.15378 0.36235,0.24017 0.57983,0.24017z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,69.3762,250.0103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3918,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,10.969000000000051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3919,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3919_fill_path",
    d: "M9.46563,38.45097l9.62,-34.50999c0.06337,-0.19115 0.08475,-0.39371 0.06269,-0.59387c-0.02206,-0.20016 -0.08704,-0.39322 -0.19051,-0.56598c-0.10347,-0.17276 -0.24299,-0.32118 -0.40904,-0.4351c-0.16605,-0.11393 -0.35472,-0.19068 -0.55315,-0.22504l-6.44,-2c-0.18365,-0.08208 -0.38293,-0.12333 -0.58407,-0.12088c-0.20114,0.00245 -0.39936,0.04852 -0.58096,0.13504c-0.1816,0.08652 -0.34226,0.21144 -0.47088,0.3661c-0.12862,0.15467 -0.22214,0.33539 -0.27409,0.52972l-9.62,34.52c-0.03885,0.10879 -0.03336,0.22848 0.01529,0.33325c0.04864,0.10477 0.13654,0.18622 0.24471,0.22675c0.05516,0.01337 0.11243,0.01568 0.1685,0.00681c0.05606,-0.00887 0.10982,-0.02875 0.15816,-0.0585c0.04834,-0.02975 0.09031,-0.06876 0.1235,-0.11481c0.03318,-0.04605 0.05692,-0.09823 0.06985,-0.1535l0.12,-0.37l7.86,2.42999",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.995599999999996,12.431900000000041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3920,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3920_fill_path",
    d: "M10.79,0.03809c-0.35132,-0.08462 -0.72184,-0.027 -1.03088,0.16029c-0.30904,0.1873 -0.53157,0.4891 -0.61912,0.83971l-9.14,32.95l3.79,1.19l9.56,-34.33z",
    fillRule: "nonzero",
    fill: "rgb(210, 216, 219)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.785600000000002,13.28000000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3921,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3921_fill_path",
    d: "M4,35.53999l9.13,-32.94998c0.12377,-0.33968 0.1093,-0.71438 -0.0403,-1.0435c-0.1496,-0.32913 -0.42239,-0.58641 -0.7597,-0.71651l-2.74001,-0.83l-9.59,34.33z",
    fillRule: "nonzero",
    fill: "rgb(226, 230, 232)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.21560000000001,14.260000000000048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3922,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3922_fill_path",
    d: "M0,14c0,0 2.09,-9.92 4.2,-14c-0.55,2.54 -0.63,3.73 -4.2,14z",
    fillRule: "nonzero",
    fill: "rgb(163, 174, 178)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,13.315600000000003,17.58000000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3923,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3923_fill_path",
    d: "M0,3.38l3.05,0.92999l-0.22,-1.92l1.36,-1.42999l-3.16,-0.96001z",
    fillRule: "nonzero",
    fill: "rgb(175, 145, 219)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,29.875600000000006,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3924,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3924_fill_path",
    d: "M0,49.75999v-49.75999h11.21001v49.75999",
    fillRule: "nonzero",
    fill: "rgb(163, 217, 232)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,29.885599999999997,6.32000000000005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3925,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3925_fill_path",
    d: "M0,0h11.2v1.78999h-11.2z",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,29.885599999999997,8.920000000000016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3926,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3926_fill_path",
    d: "M0,0h11.2v1.79001h-11.2z",
    fillRule: "nonzero",
    fill: "rgb(111, 220, 191)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.165599999999998,4.360000000000014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3927,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3927_fill_path",
    d: "M0,45.39999v-45.39999h10.59v45.39999",
    fillRule: "nonzero",
    fill: "rgb(221, 133, 156)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.165599999999998,14.28000000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3928,
    opacity: 0.5400000214576721,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3928_fill_path",
    d: "M0,0h10.59v1.62001h-10.59z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.165599999999998,16.630000000000052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3929,
    opacity: 0.5400000214576721,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3929_fill_path",
    d: "M0,0h10.59v1.62h-10.59z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,282.4219,406.5103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3930,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.381000000000029,0.4497000000000071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3931,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3931_fill_path",
    d: "M14.62898,4.98023h-14.48999c-1.9,-6.55 16.33999,-6.73 14.48999,0z",
    fillRule: "evenodd",
    fill: "rgb(186, 188, 190)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.550000000000011,0.313000000000045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3932,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3932_fill_path",
    d: "M0,3.17694c1.46,-4.11 12.87001,-4.36 14.42001,0c-2.28159,0.96371 -4.73325,1.46024 -7.21002,1.46024c-2.47677,0 -4.9284,-0.49653 -7.20999,-1.46024z",
    fillRule: "evenodd",
    fill: "rgb(229, 230, 231)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.060000000000002,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3933,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3933_fill_path",
    d: "M1.39999,0.56998c0,0.02387 -0.00949,0.04678 -0.02637,0.06366c-0.01688,0.01688 -0.03976,0.02637 -0.06363,0.02637h-1.22c-0.02387,0 -0.04675,-0.00949 -0.06363,-0.02637c-0.01688,-0.01688 -0.02637,-0.03979 -0.02637,-0.06366v-0.37c0,-0.11 0.26001,-0.19998 0.57001,-0.19998h0.25998c0.31,0 0.57001,0.08998 0.57001,0.19998z",
    fillRule: "evenodd",
    fill: "rgb(66, 66, 67)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,5.3899000000000115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3934,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3934_fill_path",
    d: "M0.29999,0h24.92001c0.16569,0 0.29999,0.13433 0.29999,0.30002v0.20999c0,0.16569 -0.1343,0.29999 -0.29999,0.29999h-24.92001c-0.16569,0 -0.29999,-0.1343 -0.29999,-0.29999v-0.20999c0,-0.16569 0.1343,-0.30002 0.29999,-0.30002z",
    fillRule: "nonzero",
    fill: "rgb(178, 178, 216)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20.3218,298.8101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3935,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3935_fill_path",
    d: "M0,0h99.83v4.23001h-99.83z",
    fillRule: "nonzero",
    fill: "rgb(64, 64, 64)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,59.1519,-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3936,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,108.58999999999999,142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3937,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3937_fill_path",
    d: "M23.49001,12.86c0,7.11 -5.26,12.88 -11.75,12.88c-6.49,0 -11.74001,-5.77 -11.74001,-12.88c0,-7.11 5.26001,-12.86 11.74001,-12.86c6.48,0 11.75,5.74 11.75,12.86z",
    fillRule: "nonzero",
    fill: "rgb(255, 249, 204)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,154.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3938,
    opacity: 0.44999998807907104,
    style: {
      mixBlendMode: "luminosity"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3938_fill_path",
    d: "M93.98,0l-93.98,258.44h248.78999l-102.20999,-258.44z",
    fillRule: "nonzero",
    fill: "rgb(255, 244, 197)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,119.01,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3939,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3939_fill_path",
    d: "M0,0h2v101h-2z",
    fillRule: "nonzero",
    fill: "rgb(175, 145, 219)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.3781,100.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3940,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3940_fill_path",
    d: "M5.90183,5.26v-2.79c0.02442,-0.62801 -0.20056,-1.24019 -0.62584,-1.70293c-0.42528,-0.46275 -1.01633,-0.73849 -1.64417,-0.76707h-1.37c-0.62606,0.03113 -1.21458,0.30799 -1.63773,0.77045c-0.42315,0.46246 -0.64676,1.07319 -0.62228,1.69955v2.79c1.88725,-0.77298 4.00275,-0.77298 5.89,0z",
    fillRule: "nonzero",
    fill: "rgb(178, 178, 216)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,111.67,104.74000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3941,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3941_fill_path",
    d: "M17.34,9.51008v8.75l-0.36,-0.08c-5.04887,-0.78299 -10.18319,-0.84695 -15.25,-0.18999l-1.36,0.18999l-0.37,0.08v-8.75c0.00273,-0.47167 0.03613,-0.94267 0.09999,-1.41c0.0679,-0.50092 0.1749,-0.99576 0.32001,-1.48c0,-0.06 0,-0.12 0.05,-0.18c0.07455,-0.23766 0.16133,-0.4713 0.25999,-0.7c-0.00574,-0.03979 -0.00574,-0.08021 0,-0.12l0.18001,-0.41c0.07,-0.15 0.13999,-0.29999 0.21999,-0.43999c0.28853,-0.53161 0.62314,-1.03689 1,-1.51c0.42538,-0.52534 0.90467,-1.00462 1.43001,-1.43c0.16,-0.12 0.32,-0.25 0.5,-0.36c0.17247,-0.12488 0.35284,-0.23844 0.53999,-0.34c0.17777,-0.11291 0.36136,-0.2164 0.55,-0.31001l0.56,-0.24c0.92997,-0.381 1.92502,-0.57797 2.93001,-0.58c1.02829,-0.00451 2.04749,0.19253 3,0.58c1.27878,0.53555 2.41982,1.35349 3.33766,2.39256c0.91784,1.03907 1.58871,2.27234 1.96234,3.60744c0.27495,0.95205 0.4097,1.93909 0.39999,2.93z",
    fillRule: "nonzero",
    fill: "rgb(175, 145, 219)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,94.0099,122.2765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3942,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3942_fill_path",
    d: "M52.67,32.58355h-52.67l1.58,-12.67c1,-7.93 8.10999,-17.48 16.09999,-19.2l0.37001,-0.07999l1.42999,-0.2c5.04473,-0.63872 10.15386,-0.5714 15.18001,0.2l0.34,0.09c8,1.72 15.14,11.27 16.11,19.2z",
    fillRule: "nonzero",
    fill: "rgb(175, 145, 219)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,111.65990000000001,111.36000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3943,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3943_fill_path",
    d: "M17.35001,2.89h-17.35001c0.00273,-0.47167 0.03614,-0.94267 0.10001,-1.41c0.0679,-0.50092 0.1749,-0.99576 0.32001,-1.48h16.5c0.28128,0.93771 0.42609,1.91102 0.42999,2.89zM17.35001,8.84v2.8l-0.36,-0.08c-5.04887,-0.78299 -10.18319,-0.84695 -15.25,-0.18999l-1.36,0.18999l-0.37,0.08v-2.67c3,-0.3 6.16999,-0.46 9.37999,-0.46c2.7,0 5.36001,0.12999 7.96001,0.32999z",
    fillRule: "nonzero",
    fill: "rgb(178, 178, 216)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,91.95,152.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3944,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3944_fill_path",
    d: "M54.73,0h-52.69h-2.03999v3.76h56.77v-3.76z",
    fillRule: "nonzero",
    fill: "rgb(178, 178, 216)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.9918,412.2998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3945,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3945_fill_path",
    d: "M5,0h272c2.76142,0 5,2.23858 5,5c0,2.76142 -2.23858,5 -5,5h-272c-2.76142,0 -5,-2.23858 -5,-5c0,-2.76142 2.23858,-5 5,-5z",
    fillRule: "nonzero",
    fill: "rgb(64, 64, 64)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.2367,369.9502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3946,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,19.88979999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3947,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3947_fill_path",
    d: "M7.72517,4.1602c0,0.23074 -0.09167,0.45202 -0.25482,0.61517c-0.16316,0.16316 -0.38444,0.25482 -0.61518,0.25482c-0.23074,0 -0.45202,-0.09167 -0.61518,-0.25482c-0.16316,-0.16316 -0.25482,-0.38444 -0.25482,-0.61517c-0.02367,-0.31287 -0.11584,-0.61673 -0.27,-0.89001c-0.21904,-0.43175 -0.52959,-0.81054 -0.91,-1.10999c-0.32935,-0.2636 -0.73815,-0.40809 -1.16,-0.41c-0.2514,0.01527 -0.49674,0.08343 -0.72,0.20001l-0.16,0.09c-0.2747,0.17844 -0.50672,0.41522 -0.67955,0.69348c-0.17283,0.27826 -0.28225,0.59117 -0.32045,0.9165c-0.10102,0.95487 0.10196,1.91726 0.58,2.75c0.08,0.16 0.18,0.34002 0.29,0.52002c0.78284,1.10259 1.6924,2.10948 2.71,3c1.79,1.72 3.65,3.51 4.2,6c0.03765,0.11519 0.05082,0.23696 0.03867,0.35754c-0.01215,0.12058 -0.04937,0.23729 -0.10925,0.34265c-0.05989,0.10536 -0.14112,0.19706 -0.2385,0.2692c-0.09738,0.07214 -0.20877,0.12313 -0.327,0.14972c-0.11824,0.02659 -0.24072,0.02818 -0.35961,0.00467c-0.11889,-0.02351 -0.23156,-0.07159 -0.33078,-0.14117c-0.09922,-0.06958 -0.18281,-0.15914 -0.24541,-0.26291c-0.0626,-0.10377 -0.10283,-0.21947 -0.11811,-0.33969c-0.44,-1.95 -2.11,-3.55001 -3.71,-5.10001c-1.13751,-0.99668 -2.14539,-2.13223 -3,-3.38c-0.12,-0.2 -0.24,-0.41 -0.35,-0.63c-0.64636,-1.16246 -0.90885,-2.49945 -0.75,-3.82001c0.08303,-0.57818 0.29168,-1.13114 0.61129,-1.62006c0.31961,-0.48891 0.74242,-0.9019 1.23871,-1.20993l0.28,-0.14999c0.45246,-0.23477 0.95074,-0.36788 1.46,-0.39001c0.81438,-0.00847 1.60756,0.25946 2.25,0.76001c0.592,0.45734 1.07384,1.04169 1.41,1.70999c0.26588,0.52485 0.4127,1.1019 0.43,1.69z",
    fillRule: "nonzero",
    fill: "rgb(204, 125, 150)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.701300000000003,18.939999999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3948,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3948_fill_path",
    d: "M17.76386,0c0.08,4.69 -1.07,19.41997 -4.84,23.21997h-8.07999c-3.77,-3.8 -4.92,-18.52997 -4.84,-23.21997z",
    fillRule: "evenodd",
    fill: "rgb(221, 133, 156)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.938400000000001,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3949,
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "3949_stroke_path",
    d: "M1.46672,12.38998c-0.56,-0.56 -3,-3.51998 0,-6.19998c3,-2.68 1.92999,-3.76 0.10999,-6.19",
    fill: "none",
    stroke: "rgb(209, 209, 209)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.138400000000004,4.490000000000009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3950,
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "3950_stroke_path",
    d: "M1.46672,12.38998c-0.56,-0.56 -3,-3.51997 0,-6.18997c3,-2.67 1.93,-3.76001 0.11,-6.20001",
    fill: "none",
    stroke: "rgb(209, 209, 209)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.025900000000007,4.490000000000009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3951,
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "3951_stroke_path",
    d: "M1.46927,12.38998c-0.57,-0.56 -3,-3.51997 0,-6.18997c3,-2.67 1.92,-3.76001 0.1,-6.20001",
    fill: "none",
    stroke: "rgb(209, 209, 209)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "15.4049 25.4049",
    strokeOpacity: 1
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9995430622688748,0,0.03490481287456702,1.0001523280439077,131.1619,266.2402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3952,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,81.74000000000001,127.74009999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3953,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3953_fill_path",
    d: "M35.39,15.73999l-2.47,-15.73999h-30.45l-2.47,15.73999z",
    fillRule: "nonzero",
    fill: "rgb(210, 207, 214)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.28999999999999204,107.49009999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3954,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3954_fill_path",
    d: "M3.3,22.06998c-0.87613,-0.00265 -1.71548,-0.35253 -2.33406,-0.97299c-0.61858,-0.62046 -0.96594,-1.46087 -0.96593,-2.33701v-18.75998h198.28999v18.75998c-0.00264,0.87706 -0.35221,1.71744 -0.97238,2.33762c-0.62017,0.62017 -1.46056,0.96974 -2.33762,0.97238z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,107.26009999999997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3955,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3955_fill_path",
    d: "M198.32999,0.5v18.51001c0,0.81156 -0.32238,1.58987 -0.89624,2.16373c-0.57386,0.57386 -1.35219,0.89627 -2.16376,0.89627h-191.67999c-0.80112,-0.01571 -1.56411,-0.34504 -2.12506,-0.91721c-0.56095,-0.57217 -0.87509,-1.34152 -0.87494,-2.14279v-18.51001zM198.82999,0h-198.82999v19c0,0.94244 0.37369,1.84642 1.03916,2.51376c0.66547,0.66734 1.5684,1.04359 2.51084,1.04623h191.71999c0.94417,0 1.84967,-0.37506 2.5173,-1.04269c0.66763,-0.66763 1.04269,-1.57313 1.04269,-2.5173z",
    fillRule: "nonzero",
    fill: "rgb(64, 64, 64)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.03999999999999204,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3956,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3956_fill_path",
    d: "M193.31998,0.00004h-187.84998c-0.71571,-0.00263 -1.42493,0.13572 -2.08716,0.40718c-0.66223,0.27146 -1.26451,0.6707 -1.77245,1.17493c-0.50794,0.50422 -0.91158,1.10356 -1.1879,1.76378c-0.27631,0.66022 -0.41988,1.3684 -0.4225,2.08411v103.2h198.78998v-103.2c-0.00262,-0.71571 -0.14617,-1.42388 -0.42249,-2.08411c-0.27631,-0.66022 -0.67996,-1.25956 -1.1879,-1.76378c-0.50794,-0.50422 -1.11023,-0.90347 -1.77246,-1.17493c-0.66223,-0.27146 -1.37145,-0.40981 -2.08716,-0.40718z",
    fillRule: "nonzero",
    fill: "rgb(64, 64, 64)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.389999999999986,6.490099999999984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3957,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3957_fill_path",
    d: "M0,0h184.28999v95.74001h-184.28999z",
    fillRule: "nonzero",
    fill: "rgb(227, 209, 229)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,67.30000000000001,143.4801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3958,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3958_fill_path",
    d: "M0,0h64.27v2.35999h-64.27z",
    fillRule: "nonzero",
    fill: "rgb(234, 234, 234)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,95.59,115.58009999999996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3959,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3959_fill_path",
    d: "M7.68001,3.81c0,2.1042 -1.71924,3.81 -3.84001,3.81c-2.12077,0 -3.84,-1.70579 -3.84,-3.81c0,-2.1042 1.71922,-3.81 3.84,-3.81c2.12077,0 3.84001,1.70579 3.84001,3.81z",
    fillRule: "nonzero",
    fill: "rgb(51, 51, 51)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.389999999999986,6.490099999999984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39131,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "39129_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39129,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39130,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39130_fill_path",
    d: "M0,0h184.28999v95.74001h-184.28999z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#39129_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.590000000000003,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3960,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,59.22,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3961,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3962,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3962_fill_path",
    d: "M0,0h119.55v95.74001h-119.55z",
    fillRule: "nonzero",
    fill: "rgb(86, 82, 102)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3963,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3963_fill_path",
    d: "M0,0h119.55v6.45h-119.55z",
    fillRule: "nonzero",
    fill: "rgb(176, 186, 234)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.3799999999999955,1.839999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3964,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3964_fill_path",
    d: "M2.8,1.37999c0,0.76215 -0.62681,1.38 -1.40001,1.38c-0.7732,0 -1.39999,-0.61785 -1.39999,-1.38c0,-0.76215 0.6268,-1.37999 1.39999,-1.37999c0.7732,0 1.40001,0.61784 1.40001,1.37999z",
    fillRule: "nonzero",
    fill: "rgb(232, 77, 77)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.590000000000003,1.839999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3965,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3965_fill_path",
    d: "M2.8,1.37999c0,0.76215 -0.6268,1.38 -1.39999,1.38c-0.7732,0 -1.40001,-0.61785 -1.40001,-1.38c0,-0.76215 0.62681,-1.37999 1.40001,-1.37999c0.7732,0 1.39999,0.61784 1.39999,1.37999z",
    fillRule: "nonzero",
    fill: "rgb(242, 221, 119)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.54000000000002,1.839999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3966,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3966_fill_path",
    d: "M2.79999,1.37999c0,0.76215 -0.6268,1.38 -1.39999,1.38c-0.7732,0 -1.39999,-0.61785 -1.39999,-1.38c0,-0.76215 0.6268,-1.37999 1.39999,-1.37999c0.7732,0 1.39999,0.61784 1.39999,1.37999z",
    fillRule: "nonzero",
    fill: "rgb(78, 183, 133)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.799000000000007,9.04000000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3967,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3968,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3968_fill_path",
    d: "M0.08092,2.84c1.17,-0.07 1.49001,-0.16 1.49001,-0.37c0,-0.21 -0.33001,-0.43 -1.24001,-0.55v-0.34l1.11,-0.86h-1.3v-0.68001h2.05l0.06,0.68001l-1.06,0.79999c0.83,0.18 1.14999,0.51001 1.14999,0.90001c0,0.6 -0.66999,1.05 -2.20999,1.13zM3.13092,3.47l-0.07001,-0.61c1,-0.7 1.5,-1.16 1.5,-1.61c0,-0.45 -0.31999,-0.5 -1.39999,-0.53l0.06999,-0.72c1.63,0 2.11,0.46 2.11,1c0,0.54 -0.49999,1.13999 -1.31999,1.75999h1.39v0.67zM0.08092,9.49001c1.17,-0.07 1.49001,-0.17 1.49001,-0.38c0,-0.21 -0.33001,-0.42001 -1.24001,-0.54001v-0.34l1.11,-0.87h-1.3v-0.67001h2.05l0.06,0.67001l-1.06,0.81c0.83,0.17 1.14999,0.50998 1.14999,0.88998c0,0.61 -0.66999,1.06001 -2.20999,1.14001zM3.13092,10.12001l-0.07001,-0.61002c1,-0.71 1.5,-1.15999 1.5,-1.60999c0,-0.45 -0.31999,-0.5 -1.39999,-0.53l0.06999,-0.73001c1.63,0 2.11,0.47 2.11,1c0,0.53 -0.49999,1.14999 -1.31999,1.76999h1.39v0.67001zM0.08092,16.14c1.17,-0.07 1.49001,-0.17 1.49001,-0.38c0,-0.21 -0.33001,-0.42001 -1.24001,-0.54001v-0.34l1.11,-0.87h-1.3v-0.67001h2.05l0.06,0.67001l-1.06,0.81c0.83,0.17 1.14999,0.51001 1.14999,0.89001c0,0.61 -0.66999,1.05998 -2.20999,1.13998zM5.23091,16.23v0.59h-0.73v-0.59h-1.44c-0.01117,-0.97004 0.0997,-1.93764 0.33,-2.88l0.84,0.05002l-0.55,2.15997h0.82001v-1.12997l0.73,-0.08002v1.16h0.37001l-0.07001,0.67001zM0.08092,22.78999c1.17,-0.08 1.49001,-0.17 1.49001,-0.38c0,-0.21 -0.33001,-0.42998 -1.24001,-0.53998v-0.35001l1.11,-0.86002h-1.3v-0.67999h2.05l0.06,0.67999l-1.06,0.81c0.83,0.17 1.14999,0.51001 1.14999,0.89001c0,0.6 -0.66999,1.06 -2.20999,1.13zM3.17091,23.49998v-0.72c1.17,-0.09 1.53,-0.19999 1.53,-0.48999c0,-0.29 -0.39,-0.42001 -1.44,-0.54001l0.11,-1.76999h2l-0.06,0.69h-1.31v0.59c1.11,0.17 1.44,0.56 1.44,1c-0.04,0.63 -0.7,1.14999 -2.27,1.23999zM0.08092,29.43001c1.17,-0.07 1.49001,-0.16003 1.49001,-0.37003c0,-0.21 -0.33001,-0.42999 -1.24001,-0.54999v-0.34l1.11,-0.86002h-1.3v-0.67999h2.05l0.06,0.67999l-1.06,0.81003c0.83,0.17 1.14999,0.50998 1.14999,0.88998c0,0.6 -0.66999,1.05 -2.20999,1.13zM3.00091,28.77998c0,-1 0.56,-1.72999 1.83,-2.26999l0.31999,0.64999c-0.84,0.31 -1.18999,0.61 -1.32999,1c0.78,-0.45 1.67,-0.07998 1.67,0.80002c-0.00173,0.17025 -0.03823,0.33832 -0.10724,0.49396c-0.06901,0.15564 -0.1691,0.29555 -0.29411,0.41113c-0.12501,0.11558 -0.27231,0.20443 -0.43288,0.26105c-0.16056,0.05662 -0.331,0.07983 -0.50085,0.06824c-0.16986,-0.0116 -0.33556,-0.05776 -0.48694,-0.13568c-0.15138,-0.07792 -0.28525,-0.18594 -0.39339,-0.31744c-0.10814,-0.1315 -0.18827,-0.28372 -0.23549,-0.4473c-0.04722,-0.16358 -0.06053,-0.33507 -0.03911,-0.50397zM4.76091,29.00999c0,-0.48 -0.41,-0.66999 -1,-0.39999v0.09c0,0.59 0.25001,0.82999 0.56001,0.82999c0.31,0 0.43999,-0.16999 0.43999,-0.51999zM0.08092,36.08c1.17,-0.07 1.49001,-0.16 1.49001,-0.37c0,-0.21 -0.33001,-0.43002 -1.24001,-0.55002v-0.34l1.11,-0.85999h-1.3v-0.68002h2.05l0.06,0.68002l-1.06,0.79999c0.83,0.18 1.14999,0.50999 1.14999,0.89999c0,0.6 -0.66999,1.05 -2.20999,1.13zM3.39091,36.68001c0.3367,-0.93566 0.77604,-1.83114 1.31,-2.67001h-1.59999l0.06,-0.70001h2.33v0.68002c-0.53028,0.88519 -0.96601,1.82367 -1.3,2.79999zM0.08092,42.73c1.17,-0.07 1.49001,-0.17 1.49001,-0.38c0,-0.21 -0.33001,-0.42001 -1.24001,-0.54001v-0.34l1.11,-0.87h-1.3v-0.66998h2.05l0.06,0.66998l-1.06,0.81c0.83,0.17 1.14999,0.51001 1.14999,0.89001c0,0.61 -0.66999,1.05998 -2.20999,1.13998zM3.00091,42.55998c0.18316,-0.05691 0.34395,-0.16963 0.45988,-0.32242c0.11594,-0.15279 0.18123,-0.33798 0.18674,-0.52969c0.00551,-0.19172 -0.04903,-0.38039 -0.15601,-0.53958c-0.10697,-0.15919 -0.26103,-0.28096 -0.44061,-0.3483c0,-0.48 0.42,-1 1.22,-1c0.63,0 1.12999,0.33 1.12999,0.84c-0.01148,0.18594 -0.07467,0.36499 -0.18245,0.51694c-0.10778,0.15195 -0.25586,0.27078 -0.42755,0.34308c0.36,0.21 0.68001,0.46998 0.68001,0.88998c0,0.42 -0.49,1 -1.3,1c-0.81,0 -1.17,-0.32001 -1.17,-0.85001zM4.71092,42.55998c0,-0.25 -0.32001,-0.43998 -0.68001,-0.63998c-0.08515,0.05846 -0.15563,0.13581 -0.20593,0.22601c-0.05031,0.0902 -0.07907,0.19081 -0.08406,0.29398c0,0.25 0.15,0.44 0.5,0.44c0.35,0 0.48,-0.17001 0.48,-0.35001zM4.39091,41.34999c0.07841,-0.05434 0.14346,-0.12577 0.19023,-0.20892c0.04677,-0.08315 0.07405,-0.17583 0.07977,-0.27106c0,-0.23 -0.12,-0.40002 -0.44,-0.40002c-0.32,0 -0.42,0.14001 -0.42,0.29001c0,0.15 0.27999,0.39 0.59999,0.56zM0.08092,49.37999c1.17,-0.07 1.49001,-0.17 1.49001,-0.38c0,-0.21 -0.33001,-0.42998 -1.24001,-0.53998v-0.35001l1.11,-0.86002h-1.3v-0.66998h2.05l0.06,0.66998l-1.06,0.81c0.83,0.17 1.14999,0.51001 1.14999,0.89001c0,0.6 -0.66999,1.05998 -2.20999,1.13998zM3.33092,49.48c0.84,-0.32 1.19,-0.61 1.33,-1c-0.78,0.44 -1.67,0.08001 -1.67,-0.79999c0.00173,-0.17025 0.03821,-0.33835 0.10722,-0.49399c0.06901,-0.15564 0.1691,-0.29555 0.29411,-0.41113c0.12501,-0.11558 0.27231,-0.20439 0.43288,-0.26102c0.16056,-0.05662 0.331,-0.07986 0.50085,-0.06827c0.16986,0.0116 0.33556,0.05779 0.48694,0.13571c0.15138,0.07792 0.28525,0.18591 0.39339,0.31741c0.10814,0.1315 0.18828,0.28372 0.2355,0.4473c0.04722,0.16358 0.06052,0.33507 0.03909,0.50397c0,1 -0.56,1.73002 -1.83,2.27002zM4.74092,48.02998v-0.09c0,-0.59 -0.25001,-0.82999 -0.56001,-0.82999c-0.31,0 -0.45999,0.17001 -0.45999,0.51001c0,0.49 0.41,0.66997 1.02,0.40997zM2.16092,56.06999v0.59h-0.73001v-0.59h-1.42999c-0.01117,-0.97004 0.0997,-1.93764 0.33,-2.88l0.84,0.05002l-0.55,2.16h0.82001v-1.08002l0.73,-0.07999v1.16h0.36l-0.06,0.66998zM2.94092,54.99998c0,-1.11 0.51,-1.84998 1.34,-1.84998c0.83,0 1.25999,0.64998 1.25999,1.72998c0,1.08 -0.50999,1.85001 -1.34999,1.85001c-0.84,0 -1.25,-0.65001 -1.25,-1.73001zM3.69092,54.93001l1.05,-0.54001c-0.08,-0.38 -0.25001,-0.61002 -0.51001,-0.61002c-0.26,0 -0.53999,0.38002 -0.53999,1.08002zM4.79091,55.02l-1,0.53c0.08,0.37 0.24,0.59 0.5,0.59c0.26,0 0.5,-0.42 0.5,-1.12zM2.16092,62.71999v0.58002h-0.73001v-0.58002h-1.42999c-0.01224,-0.97009 0.09864,-1.93782 0.33,-2.88l0.84,0.05002l-0.55,2.16h0.82001v-1.08002l0.73,-0.07999v1.16h0.36l-0.06,0.66998zM3.09091,63.3v-0.64999h0.91v-1.76001h-0.81v-0.57001l0.81,-0.09v-0.41l0.75999,-0.06v2.88h0.82001l-0.06,0.64999zM2.16092,69.36v0.59h-0.73001v-0.59h-1.42999c-0.01172,-0.96677 0.09917,-1.93112 0.33,-2.87l0.84,0.04999l-0.55,2.14999h0.82001v-1.06998l0.73,-0.08002v1.14999h0.36l-0.06,0.67001zM3.13092,69.95l-0.07001,-0.61002c1,-0.71 1.5,-1.15999 1.5,-1.60999c0,-0.45 -0.31999,-0.5 -1.39999,-0.53l0.06999,-0.73001c1.63,0 2.11,0.47002 2.11,1.05002c0,0.58 -0.49999,1.13998 -1.31999,1.75998h1.39v0.67001zM2.16092,76.00999v0.59h-0.73001v-0.59h-1.42999c-0.01117,-0.97004 0.0997,-1.93764 0.33,-2.88l0.84,0.05002l-0.55,2.15997h0.82001v-1.10999l0.73,-0.07001v1.14999h0.36l-0.06,0.67001zM3.15091,75.96999c1.17,-0.07 1.49001,-0.17 1.49001,-0.38c0,-0.21 -0.33001,-0.41998 -1.24001,-0.53998v-0.34l1.11,-0.87003h-1.29999v-0.66998h2l0.06,0.66998l-1.06,0.81003c0.83,0.17 1.14999,0.50998 1.14999,0.88998c0,0.61 -0.67001,1.06001 -2.21001,1.14001zM2.16092,82.65999v0.57001h-0.73001v-0.59h-1.42999c-0.01117,-0.97004 0.0997,-1.93764 0.33,-2.88l0.84,0.04999l-0.55,2.16h0.82001v-1.07999l0.73,-0.08002v1.16h0.36l-0.06,0.67001zM5.23091,82.65999v0.57001h-0.73v-0.59h-1.44c-0.01117,-0.97004 0.0997,-1.93764 0.33,-2.88l0.84,0.04999l-0.55,2.16h0.82001v-1.07999l0.73,-0.08002v1.16h0.37001l-0.07001,0.67001z",
    fillRule: "nonzero",
    fill: "rgb(112, 109, 132)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,17.22,9.600000000000023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3969,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3970,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3970_fill_path",
    d: "M0,0h70.96001v3.06999h-70.96001z",
    fillRule: "nonzero",
    fill: "rgb(163, 132, 141)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,6.589999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3971,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3971_fill_path",
    d: "M0,0h75.56001v3.06998h-75.56001z",
    fillRule: "nonzero",
    fill: "rgb(165, 132, 146)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,13.239999999999952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3972,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3972_fill_path",
    d: "M0,0h61.58v3.07001h-61.58z",
    fillRule: "nonzero",
    fill: "rgb(162, 132, 163)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,19.94999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3973,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3973_fill_path",
    d: "M0,0h52.68001v3.07001h-52.68001z",
    fillRule: "nonzero",
    fill: "rgb(144, 132, 160)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,26.529899999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3974,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3974_fill_path",
    d: "M0,0h43.68001v3.07001h-43.68001z",
    fillRule: "nonzero",
    fill: "rgb(131, 133, 158)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,33.22999999999996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3975,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3975_fill_path",
    d: "M0,0h73.08v3.07001h-73.08z",
    fillRule: "nonzero",
    fill: "rgb(131, 146, 155)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,40.089999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3976,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3976_fill_path",
    d: "M0,0h85.72002v3.06998h-85.72002z",
    fillRule: "nonzero",
    fill: "rgb(130, 153, 149)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,46.5299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3977,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3977_fill_path",
    d: "M0,0h71.53999v3.07001h-71.53999z",
    fillRule: "nonzero",
    fill: "rgb(132, 153, 139)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,53.17999999999995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3978,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3978_fill_path",
    d: "M0,0h67.52v3.06998h-67.52z",
    fillRule: "nonzero",
    fill: "rgb(137, 153, 133)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,59.76999999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3979,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3979_fill_path",
    d: "M0,0h32.10001v3.07001h-32.10001z",
    fillRule: "nonzero",
    fill: "rgb(151, 153, 135)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,66.41999999999996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3980,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3980_fill_path",
    d: "M0,0h93.48v3.07001h-93.48z",
    fillRule: "nonzero",
    fill: "rgb(153, 148, 136)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.12000000000000455,73.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3981,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3981_fill_path",
    d: "M0,0h67.52v3.07001h-67.52z",
    fillRule: "nonzero",
    fill: "rgb(153, 142, 138)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,79.7199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3982,
    opacity: 0.38999998569488525,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3982_fill_path",
    d: "M0,0h50.03001v3.07001h-50.03001z",
    fillRule: "nonzero",
    fill: "rgb(153, 140, 140)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,125.6,49.660000000000025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3983,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.09000000000003183,3.939899999999966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3984,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3984_fill_path",
    d: "M0,0h48.73999v38.57001h-48.73999z",
    fillRule: "nonzero",
    fill: "rgb(51, 51, 51)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3985,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3985_fill_path",
    d: "M0.75,0h47.22c0.22809,0 0.44684,0.09058 0.60812,0.25186c0.16128,0.16128 0.25189,0.38004 0.25189,0.60812v4.38h-48.83002v-4.48999c0,-0.19891 0.07904,-0.38968 0.2197,-0.53033c0.14065,-0.14065 0.33139,-0.21967 0.5303,-0.21967z",
    fillRule: "nonzero",
    fill: "rgb(211, 211, 211)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.7700000000000387,1.849899999999991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3986,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3986_fill_path",
    d: "M2.07999,1.04001c0,0.57438 -0.4656,1.04001 -1.03998,1.04001c-0.57438,0 -1.04001,-0.46563 -1.04001,-1.04001c0,-0.57438 0.46563,-1.04001 1.04001,-1.04001c0.57438,0 1.03998,0.46563 1.03998,1.04001z",
    fillRule: "nonzero",
    fill: "rgb(232, 77, 77)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.660000000000025,1.849899999999991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3987,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3987_fill_path",
    d: "M2.08002,1.04001c0,0.57438 -0.46563,1.04001 -1.04001,1.04001c-0.57438,0 -1.04001,-0.46563 -1.04001,-1.04001c0,-0.57438 0.46563,-1.04001 1.04001,-1.04001c0.57438,0 1.04001,0.46563 1.04001,1.04001z",
    fillRule: "nonzero",
    fill: "rgb(242, 221, 119)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.370000000000005,1.849899999999991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3988,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3988_fill_path",
    d: "M2.07999,1.04001c0,0.57438 -0.46563,1.04001 -1.04001,1.04001c-0.57438,0 -1.03998,-0.46563 -1.03998,-1.04001c0,-0.57438 0.4656,-1.04001 1.03998,-1.04001c0.57438,0 1.04001,0.46563 1.04001,1.04001z",
    fillRule: "nonzero",
    fill: "rgb(78, 183, 133)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.1118000000000166,8.869799999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3989,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3989_fill_path",
    d: "M0.41812,3.91019c-0.10681,-0.00025 -0.20987,-0.03936 -0.28998,-0.11002c-0.04021,-0.03473 -0.07246,-0.07772 -0.09457,-0.12604c-0.02211,-0.04832 -0.03357,-0.10083 -0.03357,-0.15396c0,-0.05313 0.01146,-0.10565 0.03357,-0.15396c0.02211,-0.04832 0.05436,-0.0913 0.09457,-0.12604l1.35999,-1.28l-1.35999,-1.29001c-0.04,-0.03379 -0.07216,-0.07589 -0.09421,-0.12338c-0.02205,-0.0475 -0.03348,-0.09925 -0.03348,-0.15161c0,-0.05237 0.01143,-0.10408 0.03348,-0.15158c0.02205,-0.0475 0.05421,-0.08962 0.09421,-0.12341c0.03808,-0.0381 0.08327,-0.06834 0.13303,-0.08896c0.04976,-0.02062 0.10309,-0.03122 0.15695,-0.03122c0.05386,0 0.10722,0.0106 0.15698,0.03122c0.04976,0.02062 0.09495,0.05086 0.13303,0.08896l1.66,1.56c0.03925,0.03506 0.07033,0.0783 0.09106,0.12668c0.02073,0.04838 0.03061,0.10071 0.02893,0.15332c0.00024,0.05093 -0.01032,0.10135 -0.03101,0.14789c-0.02069,0.04654 -0.05103,0.08815 -0.08899,0.1221l-1.66,1.57001c-0.08102,0.06913 -0.18352,0.10803 -0.29001,0.11002z",
    fillRule: "nonzero",
    fill: "rgb(131, 229, 171)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.53000000000003,11.999899999999968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3990,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3990_fill_path",
    d: "M3.22,0.39011c-0.0013,-0.05253 -0.01293,-0.10431 -0.03424,-0.15234c-0.02131,-0.04804 -0.05186,-0.09138 -0.08994,-0.12759c-0.03808,-0.03622 -0.08292,-0.06458 -0.13196,-0.08347c-0.04904,-0.01888 -0.10131,-0.02791 -0.15384,-0.02658h-2.42001c-0.05122,0 -0.10194,0.01006 -0.14926,0.02966c-0.04732,0.0196 -0.09028,0.04835 -0.1265,0.08456c-0.03621,0.03621 -0.06496,0.07921 -0.08456,0.12653c-0.0196,0.04732 -0.02969,0.09802 -0.02969,0.14923c0,0.05122 0.01009,0.10194 0.02969,0.14926c0.0196,0.04732 0.04835,0.09031 0.08456,0.12653c0.03621,0.03621 0.07918,0.06493 0.1265,0.08453c0.04732,0.0196 0.09805,0.02969 0.14926,0.02969h2.42001c0.05253,0.00133 0.1048,-0.00773 0.15384,-0.02661c0.04904,-0.01888 0.09388,-0.04725 0.13196,-0.08347c0.03808,-0.03622 0.06863,-0.07956 0.08994,-0.12759c0.02131,-0.04804 0.03294,-0.09981 0.03424,-0.15234z",
    fillRule: "nonzero",
    fill: "rgb(131, 229, 171)",
    fillOpacity: 0,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,7.470000000000027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39128,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "39126_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39126,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39127,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39127_fill_path",
    d: "M0,0h52.38v81.84001h-52.38z",
    fillRule: "nonzero",
    fill: "rgb(0, 0, 0)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#39126_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.1,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3991,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3992,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3993,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3993_fill_path",
    d: "M3.56999,0h45.33c1.97166,0 3.57001,1.59834 3.57001,3.56999v234.99001c0,1.97166 -1.59835,3.57001 -3.57001,3.57001h-45.33c-1.97166,0 -3.56999,-1.59835 -3.56999,-3.57001v-234.99001c0,-1.97166 1.59834,-3.56999 3.56999,-3.56999z",
    fillRule: "nonzero",
    fill: "rgb(240, 240, 242)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.789999999999992,13.400000000000006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3994,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "3994_stroke_path",
    d: "M0,0h32.35001",
    fill: "none",
    stroke: "rgb(221, 133, 156)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.789999999999992,18.690000000000026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3995,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "3995_stroke_path",
    d: "M0,0h38.10001",
    fill: "none",
    stroke: "rgb(221, 133, 156)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.789999999999992,23.99000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3996,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "3996_stroke_path",
    d: "M0,0h32.35001",
    fill: "none",
    stroke: "rgb(221, 133, 156)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.949999999999989,32.26000000000002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3997,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3997_fill_path",
    d: "M3.22,0h34.14999c1.77836,0 3.22,1.44164 3.22,3.22v21.70999c0,1.77836 -1.44164,3.22 -3.22,3.22h-34.14999c-1.77836,0 -3.22,-1.44164 -3.22,-3.22v-21.70999c0,-1.77836 1.44164,-3.22 3.22,-3.22z",
    fillRule: "nonzero",
    fill: "rgb(242, 197, 194)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.534700000000015,35.5086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3998,
    opacity: 0.47999998927116394,
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "3998_fill_path",
    d: "M11.15526,5.35132c0.04588,1.11227 -0.24197,2.21284 -0.82655,3.16022c-0.58458,0.94737 -1.43917,1.69825 -2.45389,2.15607c-1.01472,0.45782 -2.14318,0.60165 -3.2403,0.41302c-1.09712,-0.18862 -2.11276,-0.70107 -2.91631,-1.4715c-0.80355,-0.77043 -1.35829,-1.76359 -1.5929,-2.85181c-0.23461,-1.08821 -0.13836,-2.22174 0.27637,-3.25482c0.41473,-1.03308 1.12898,-1.9185 2.05092,-2.54242c0.92194,-0.62392 2.00943,-0.95779 3.12265,-0.95874c0.71789,-0.01592 1.43186,0.10991 2.10104,0.3703c0.66919,0.26039 1.28043,0.6502 1.79875,1.14716c0.51832,0.49695 0.93352,1.09129 1.22183,1.74893c0.28831,0.65764 0.44408,1.36567 0.45837,2.08359z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.920000000000016,55.900000000000006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3999,
    opacity: 0.6800000071525574,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "3999_stroke_path",
    d: "M0,0h16.75999",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.920000000000016,51.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39100,
    opacity: 0.6800000071525574,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "39100_stroke_path",
    d: "M0,0h24.52",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.949999999999989,65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39101,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39102,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39102_fill_path",
    d: "M3.34,0h31.00999c1.84463,0 3.34001,1.49537 3.34001,3.34v42.64001c0,1.84463 -1.49538,3.34 -3.34001,3.34h-31.00999c-1.84463,0 -3.34,-1.49537 -3.34,-3.34v-42.64001c0,-1.84463 1.49537,-3.34 3.34,-3.34z",
    fillRule: "nonzero",
    fill: "rgb(189, 192, 244)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.2900000000000205,24.980000000000018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39103,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "39103_stroke_path",
    d: "M0,0h11.57001",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.2900000000000205,20.35990000000004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39104,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "39104_stroke_path",
    d: "M0,0h16.93001",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.2900000000000205,15.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39105,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "39105_stroke_path",
    d: "M0,0h22.34001",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.2900000000000205,10.210000000000008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39106,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "39106_stroke_path",
    d: "M0,0h26.3",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.2900000000000205,4.910000000000025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39107,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "39107_stroke_path",
    d: "M0,0h22.34001",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.949999999999989,120.41000000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39108,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39109,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39109_fill_path",
    d: "M3.22,0h34.14999c1.77836,0 3.22,1.44164 3.22,3.22v52.01999c0,1.77836 -1.44164,3.22 -3.22,3.22h-34.14999c-1.77836,0 -3.22,-1.44164 -3.22,-3.22v-52.01999c0,-1.77836 1.44164,-3.22 3.22,-3.22z",
    fillRule: "nonzero",
    fill: "rgb(194, 231, 239)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.150000000000006,50.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39110,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "39110_stroke_path",
    d: "M0,0h13.89",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.02000000000001,46.68000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39111,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "39111_stroke_path",
    d: "M0,0h18.32999",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.7900000000000205,42.870000000000005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39112,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "39112_stroke_path",
    d: "M0,0h21.58",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.850000000000023,39.099999999999966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39113,
    opacity: 0.6800000071525574,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "39113_stroke_path",
    d: "M0,0h20.12001",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.920000000000016,35.339999999999975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39114,
    opacity: 0.6800000071525574,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "39114_stroke_path",
    d: "M0,0h13.75",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.970000000000027,4.71999999999997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39115,
    opacity: 0.47999998927116394,
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39115_fill_path",
    d: "M6.86,0h15.5c3.78867,0 6.86,3.07131 6.86,6.85999v9.49002c0,3.78867 -3.07133,6.85999 -6.86,6.85999h-15.5c-3.78867,0 -6.86,-3.07131 -6.86,-6.85999v-9.49002c0,-3.78867 3.07133,-6.85999 6.86,-6.85999z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.5,190.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39116,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39117,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39117_fill_path",
    d: "M3.34,0h33.14c1.84463,0 3.34,1.49537 3.34,3.34v33.78c0,1.84463 -1.49537,3.34 -3.34,3.34h-33.14c-1.84463,0 -3.34,-1.49537 -3.34,-3.34v-33.78c0,-1.84463 1.49537,-3.34 3.34,-3.34z",
    fillRule: "nonzero",
    fill: "rgb(208, 182, 209)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,33.99000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39118,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "39118_stroke_path",
    d: "M0,0h23.59",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,29.640000000000043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39119,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "39119_stroke_path",
    d: "M0,0h27.78",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,25.30000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39120,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "39120_stroke_path",
    d: "M0,0h23.59",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,20.49000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39121,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "39121_stroke_path",
    d: "M0,0h12.22",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,16.700000000000045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39122,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "39122_stroke_path",
    d: "M0,0h17.88",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,12.720000000000027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39123,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "39123_stroke_path",
    d: "M0,0h23.59",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,8.370000000000005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39124,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "39124_stroke_path",
    d: "M0,0h27.78",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.650000000000006,4.03000000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39125,
    opacity: 0.8100000023841858,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "NORMAL"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "39125_stroke_path",
    d: "M0,0h23.59",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.97999999999999,9.710100000000011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39132,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39132_fill_path",
    d: "M0,0h52.38v4.25h-52.38z",
    fillRule: "nonzero",
    fill: "rgb(221, 221, 221)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.97999999999999,10.92009999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39133,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39133_fill_path",
    d: "M1.86,0.92c0,0.5081 -0.41637,0.92 -0.92999,0.92c-0.51362,0 -0.93001,-0.4119 -0.93001,-0.92c0,-0.5081 0.41638,-0.92 0.93001,-0.92c0.51362,0 0.92999,0.4119 0.92999,0.92z",
    fillRule: "nonzero",
    fill: "rgb(175, 175, 175)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,18.44999999999999,10.92009999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39134,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39134_fill_path",
    d: "M1.86,0.92c0,0.5081 -0.41637,0.92 -0.92999,0.92c-0.51362,0 -0.93001,-0.4119 -0.93001,-0.92c0,-0.5081 0.41638,-0.92 0.93001,-0.92c0.51362,0 0.92999,0.4119 0.92999,0.92z",
    fillRule: "nonzero",
    fill: "rgb(234, 234, 234)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,21.75999999999999,10.92009999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39135,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39135_fill_path",
    d: "M1.86,0.92c0,0.5081 -0.41637,0.92 -0.92999,0.92c-0.51362,0 -0.93001,-0.4119 -0.93001,-0.92c0,-0.5081 0.41638,-0.92 0.93001,-0.92c0.51362,0 0.92999,0.4119 0.92999,0.92z",
    fillRule: "nonzero",
    fill: "rgb(175, 175, 175)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.879999999999995,95.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39136,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39136_fill_path",
    d: "M0,0h52.47v2.85001h-52.47z",
    fillRule: "nonzero",
    fill: "rgb(234, 234, 234)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,61.52000000000001,13.960100000000011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39137,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39137_fill_path",
    d: "M0,0h3.84v81.84001h-3.84z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,62.24,15.2761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39138,
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "39138_fill_path",
    d: "M1.01999,0h0.36c0.56333,0 1.02,0.45666 1.02,1.01999v20.17c0,0.56333 -0.45667,1.02002 -1.02,1.02002h-0.36c-0.56333,0 -1.01999,-0.45669 -1.01999,-1.02002v-20.17c0,-0.56333 0.45666,-1.01999 1.01999,-1.01999z",
    fillRule: "nonzero",
    fill: "rgb(221, 221, 221)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "NORMAL"
    }
  }))))))))))))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#397",
    attributeName: "transform",
    type: "rotate",
    values: "0 10.5319 31.92;-10 10.5319 31.92;10 10.5319 31.92;0 10.5319 31.92",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#397",
    attributeName: "transform",
    type: "translate",
    values: "10.5319 31.92;10.5319 31.92",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#397",
    href: "#397",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform4 || (_animateTransform4 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#397",
    href: "#397",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform5 || (_animateTransform5 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#397",
    href: "#397",
    attributeName: "transform",
    type: "translate",
    values: "-10.5319 -31.92;-10.5319 -31.92",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform6 || (_animateTransform6 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#398",
    attributeName: "transform",
    type: "rotate",
    values: "0 12.4824 32;-10 12.4824 32;10 12.4824 32;0 12.4824 32",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform7 || (_animateTransform7 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#398",
    attributeName: "transform",
    type: "translate",
    values: "12.4824 32;12.4824 32",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform8 || (_animateTransform8 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#398",
    href: "#398",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform9 || (_animateTransform9 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#398",
    href: "#398",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform10 || (_animateTransform10 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#398",
    href: "#398",
    attributeName: "transform",
    type: "translate",
    values: "-12.4824 -32;-12.4824 -32",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform11 || (_animateTransform11 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#399",
    attributeName: "transform",
    type: "rotate",
    values: "0 19.5566 51.03;-10 19.5566 51.03;10 19.5566 51.03;0 19.5566 51.03",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform12 || (_animateTransform12 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#399",
    attributeName: "transform",
    type: "translate",
    values: "19.5566 51.03;19.5566 51.03",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform13 || (_animateTransform13 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#399",
    href: "#399",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform14 || (_animateTransform14 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#399",
    href: "#399",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform15 || (_animateTransform15 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#399",
    href: "#399",
    attributeName: "transform",
    type: "translate",
    values: "-19.5566 -51.03;-19.5566 -51.03",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform16 || (_animateTransform16 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3910",
    attributeName: "transform",
    type: "rotate",
    values: "0 17.3929 52.33;-10 17.3929 52.33;10 17.3929 52.33;0 17.3929 52.33",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform17 || (_animateTransform17 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3910",
    attributeName: "transform",
    type: "translate",
    values: "17.3929 52.33;17.3929 52.33",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform18 || (_animateTransform18 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3910",
    href: "#3910",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform19 || (_animateTransform19 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3910",
    href: "#3910",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform20 || (_animateTransform20 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3910",
    href: "#3910",
    attributeName: "transform",
    type: "translate",
    values: "-17.3929 -52.33;-17.3929 -52.33",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform21 || (_animateTransform21 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3911",
    attributeName: "transform",
    type: "rotate",
    values: "0 11.9087 47.58;-10 11.9087 47.58;10 11.9087 47.58;0 11.9087 47.58",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform22 || (_animateTransform22 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3911",
    attributeName: "transform",
    type: "translate",
    values: "11.9087 47.58;11.9087 47.58",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform23 || (_animateTransform23 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3911",
    href: "#3911",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform24 || (_animateTransform24 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3911",
    href: "#3911",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform25 || (_animateTransform25 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3911",
    href: "#3911",
    attributeName: "transform",
    type: "translate",
    values: "-11.9087 -47.58;-11.9087 -47.58",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform26 || (_animateTransform26 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3912",
    attributeName: "transform",
    type: "rotate",
    values: "0 11.2234 41.57;-10 11.2234 41.57;10 11.2234 41.57;0 11.2234 41.57",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform27 || (_animateTransform27 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3912",
    attributeName: "transform",
    type: "translate",
    values: "11.2234 41.57;11.2234 41.57",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform28 || (_animateTransform28 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3912",
    href: "#3912",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform29 || (_animateTransform29 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3912",
    href: "#3912",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform30 || (_animateTransform30 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3912",
    href: "#3912",
    attributeName: "transform",
    type: "translate",
    values: "-11.2234 -41.57;-11.2234 -41.57",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform31 || (_animateTransform31 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3913",
    attributeName: "transform",
    type: "rotate",
    values: "0 12.9835 50.15;-10 12.9835 50.15;10 12.9835 50.15;0 12.9835 50.15",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform32 || (_animateTransform32 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3913",
    attributeName: "transform",
    type: "translate",
    values: "12.9835 50.15;12.9835 50.15",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform33 || (_animateTransform33 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3913",
    href: "#3913",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform34 || (_animateTransform34 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3913",
    href: "#3913",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform35 || (_animateTransform35 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3913",
    href: "#3913",
    attributeName: "transform",
    type: "translate",
    values: "-12.9835 -50.15;-12.9835 -50.15",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform36 || (_animateTransform36 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3914",
    attributeName: "transform",
    type: "rotate",
    values: "0 9.77 39.56;-10 9.77 39.56;10 9.77 39.56;0 9.77 39.56",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.25;0.75;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform37 || (_animateTransform37 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3914",
    attributeName: "transform",
    type: "translate",
    values: "9.77 39.56;9.77 39.56",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform38 || (_animateTransform38 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3914",
    href: "#3914",
    attributeName: "transform",
    type: "skewX",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform39 || (_animateTransform39 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3914",
    href: "#3914",
    attributeName: "transform",
    type: "skewY",
    values: "0;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform40 || (_animateTransform40 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#3914",
    href: "#3914",
    attributeName: "transform",
    type: "translate",
    values: "-9.77 -39.56;-9.77 -39.56",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#3990_fill_path",
    attributeName: "fill",
    values: "rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171;rgb(131, 229, 171",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0;0.07;0.13;0.2;0.27;0.33;0.4;0.47;0.53;0.6;0.67;0.73;0.8;0.87;0.93;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#3990_fill_path",
    attributeName: "fill-opacity",
    values: "0;1;0;1;0;1;0;1;0;1;0;1;0;1;0;1",
    dur: "3s",
    repeatCount: "indefinite",
    keyTimes: "0;0.07;0.13;0.2;0.27;0.33;0.4;0.47;0.53;0.6;0.67;0.73;0.8;0.87;0.93;1",
    fill: "freeze"
  })), _animateTransform41 || (_animateTransform41 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#3991",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 -156;0 -3",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform42 || (_animateTransform42 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#39138",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 59.0039;0 1.0039000000000016",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b954cd8c1021e4b75798249d6080df5b.svg";
export { ForwardRef as ReactComponent };